import { jsx } from "react/jsx-runtime";
import { DashboardPage } from "../features/dashboard/DashboardPage.jsx";
import { DocumentsWorkspace } from "../features/documents/DocumentsWorkspace.jsx";
import { DocumentEditor } from "../features/documents/DocumentEditor.jsx";
import { CustomerRecordsPage } from "../features/customer-records/CustomerRecordsPage.jsx";
import { TasksPage } from "../features/tasks/TasksPage.jsx";
import { ArticlesPage } from "../features/articles/ArticlesPage.jsx";
import { WorkOrderEditor, WorkOrdersPage } from "../features/work-orders/WorkOrdersPage.jsx";
import { SettingsPage } from "../features/settings/SettingsPage.jsx";
import { BackupMonitorPage } from "../features/backup-monitor/BackupMonitorPage.jsx";

export function FeatureRouter({ route: n, renderers, user }) {
  return n === `home`
    ? (0, jsx)(DashboardPage, { render: renderers.dashboard })
    : n === `docs`
      ? (0, jsx)(DocumentsWorkspace, { render: renderers.documents })
      : n === `editor`
        ? (0, jsx)(DocumentEditor, { render: renderers.documentEditor })
        : n === `client`
          ? (0, jsx)(CustomerRecordsPage, { render: renderers.customerRecords })
          : n === `tasks`
            ? (0, jsx)(TasksPage, { render: renderers.tasks })
            : n === `articles`
              ? (0, jsx)(ArticlesPage, { render: renderers.articles })
              : n === `orders`
                ? (0, jsx)(WorkOrdersPage, { render: renderers.workOrders })
                : n === `order-editor`
                  ? (0, jsx)(WorkOrderEditor, { render: renderers.workOrderEditor })
                  : n === `backup-monitor`
                    ? (0, jsx)(BackupMonitorPage, { user })
                  : (0, jsx)(SettingsPage, { render: renderers.settings });
}
